// Utility function for IST datetime formatting
// Backend now returns ISO strings with +05:30 timezone offset (IST),
// so we just parse and format them directly without adding additional offset

export const convertToIST = (date) => {
  if (!date) return null;
  // Backend already returns IST format, so just parse directly
  return new Date(date);
};

// Format date and time in IST as dd/mm/yyyy HH:MM
export const formatDateTimeIST = (date) => {
  if (!date) return 'N/A';
  
  try {
    // Parse the ISO string (already in IST from backend)
    const istDate = new Date(date);
    
    // Extract components in local display timezone
    const day = String(istDate.getDate()).padStart(2, '0');
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const year = istDate.getFullYear();
    const hours = String(istDate.getHours()).padStart(2, '0');
    const minutes = String(istDate.getMinutes()).padStart(2, '0');
    
    const result = `${day}/${month}/${year} ${hours}:${minutes}`;
    return result;
  } catch (e) {
    console.error('Error formatting date:', e);
    return 'Invalid Date';
  }
};

// Format date only in IST as dd/mm/yyyy
export const formatDateIST = (date) => {
  if (!date) return 'N/A';
  
  try {
    // Parse the ISO string (already in IST from backend)
    const istDate = new Date(date);
    
    const day = String(istDate.getDate()).padStart(2, '0');
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const year = istDate.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (e) {
    console.error('Error formatting date:', e);
    return 'Invalid Date';
  }
};

// Format time only in IST as HH:MM
export const formatTimeIST = (date) => {
  if (!date) return 'N/A';
  
  try {
    // Ensure the date string has 'Z' suffix to mark it as UTC
    let dateStr = date;
    if (typeof date === 'string' && !date.endsWith('Z')) {
      dateStr = date + 'Z';
    }
    
    const utcDate = new Date(dateStr);
    
    // Manually convert to IST by adding 5.5 hours
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(utcDate.getTime() + istOffset);
    
    const hours = String(istDate.getUTCHours()).padStart(2, '0');
    const minutes = String(istDate.getUTCMinutes()).padStart(2, '0');
    
    return `${hours}:${minutes}`;
  } catch (e) {
    console.error('Error formatting time:', e);
    return 'Invalid Time';
  }
};

// Get current time in IST
export const getNowIST = () => {
  return convertToIST(new Date());
};
